// This file should only contain action type constants.

export const SET_MEDIA = 'SET_MEDIA';
export const SET_FYUSE_UID = 'SET_FYUSE_UID';
export const SET_MY_CARS_ENABLED = 'SET_MY_CARS_ENABLED';
export const SET_MY_CARS_SAVED = 'SET_MY_CARS_SAVED';
export const SET_WIDGET_INFO = 'SET_WIDGET_INFO';
export const SET_RENDER_SETTINGS = 'SET_RENDER_SETTINGS';
export const SET_MODAL_SETTINGS = 'SET_MODAL_SETTINGS';
export const SET_IS_BEING_DRAGGED = 'SET_IS_BEING_DRAGGED';
